import { render, staticRenderFns } from "./ResourceNeWindow.vue?vue&type=template&id=b45473e8&"
import script from "./ResourceNeWindow.vue?vue&type=script&lang=js&"
export * from "./ResourceNeWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports